import { useEffect } from "react";

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [type, name] = selector.replace(/[[\]"]/g, "").split("=");
    el.setAttribute(type, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/**
 * Lightweight per-route SEO hook. Updates <title>, <meta name="description">
 * and OpenGraph/Twitter equivalents without external libraries.
 */
const useSeo = ({ title, description, path }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
      setMeta('meta[name="twitter:description"]', "content", description);
    }
    if (title) {
      setMeta('meta[name="title"]', "content", title);
      setMeta('meta[property="og:title"]', "content", title);
      setMeta('meta[name="twitter:title"]', "content", title);
    }
    if (path) {
      const url = `https://warum.enthida.de${path}`;
      setMeta('meta[property="og:url"]', "content", url);
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }
  }, [title, description, path]);
};

export default useSeo;
